<template>
  <i data-icon-name="ChevronRight"
    aria-hidden="true" 
    class="ms-Icon ms-Icon--ChevronRightMed"
    @mouseover="hover = true"
    @mouseout="hover = false"
    :style="chevStyles"></i>
</template>

<script>
export default {
  name: 'Chevnext',
  props: {
    color: {
      type: String,
      default: '#000000' 
    },
    hovercolor: {
      type: String,
      default: '#000000' 
    },
    hoverWithCircle:{
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      hover: false
    }
  },
  computed:{
    chevStyles() {
      const { color, hover, hoverWithCircle, hovercolor } = this;
      let adjustedColor = color;
      if (hover) {
        adjustedColor = hoverWithCircle ? '#2650e7' : hovercolor;
      }
      return {
        color: adjustedColor,
        background: hover && hoverWithCircle ? hovercolor : 'transparent'
      }
    }
  }
}
</script>

<style scoped>


i{
  font-size: 20px;
  border-radius: 50%;
  text-align:center;
  width: 34.5px;
  color: #1976d2;
  height: 34.5px;
  padding-top: 2px;
}

i:hover{
  cursor: pointer;
}
</style>